import React from 'react';
import Breadcrumb from '../../Shared/BreadCumb';
import {BUTTON_LINE_ICON} from '../../Shared/Constants';
import { MagnifyingGlassCircleIcon, 
PlusCircleIcon, 
PencilIcon
 } from '@heroicons/react/20/solid';
 import {getRules, updateRule} from './services/rules';
 import ClipLoader from "react-spinners/ClipLoader";
 import Notification from '../../Shared/Notifications';
 import RuleDetail from './detail';
 import { encodePermissions } from '../../Shared/functions';
 import { Dialog, DialogBackdrop, DialogPanel  } from '@headlessui/react';
 import { Switch } from '@headlessui/react';
 import { DataGrid } from '@mui/x-data-grid';
 import Paper from '@mui/material/Paper';


class RulesList extends React.Component {
    BreadcrumbPages = [
        { name: 'Administración', href: '', current: false },
        { name: 'Lista de Grupos', href: '', current: true },
    ]

    columns = [
        {
            field: 'roleName',
            headerName: 'Nombre del Grupo',
            flex: 1,
            minWidth: 200
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            width: 150,
            sortable: false,
            renderCell: (params) => (
                <div className="flex items-center space-x-2">
                    {this.props.canEdit && (
                        <button 
                            title='Actualizar'
                            onClick={() => this.props.openDialog(params.row)}
                            type="button"
                            className="rounded-full bg-gray-600 p-1 text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                        >
                            <PencilIcon 
                                style={{padding:2}}
                                aria-hidden="true" 
                                className="h-5 w-5" />
                        </button>
                    )}
                </div>
            )
        },
        {
            field: 'status',
            headerName: 'Estado',
            width: 120,
            sortable: false,
            renderCell: (params) => (
                <Switch
                    checked={params.row.active ? true : false}
                    onChange={() => this.changeState(params.row)}
                    className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                >
                    <span className="sr-only">Use setting</span>
                    <span
                        aria-hidden="true"
                        className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                    />
                </Switch>
            )
        }
    ];

    constructor(props) {
            super(props);    
            this.state = {
                dialog: false,
                enabled: false,
                rules: [],
                loading: true,
                notification:false,
                rule: null,
                detailDialog: false,
            };
            this.getList();
    }


    openByDialog = () => {
        this.props.openDialog(null);
    }

    getList = () => {
        this.setState({loading: true});
        getRules({id:null,roleName:null, limit:500}).then((response) => {
           if(response) {
                this.setState({rules: response.data.data});
           }
           this.setState({loading: false});
        })
    }

    changeState = (item) => {
        this.setState({loading:true});
        updateRule({id: item.id, 
                    active: !item.active, 
                    roleName: item.roleName, 
                    permissions: encodePermissions(item.permissions)
                }).then((response) => {
                if(response && response.data && response.data.error === 0) {
                    this.setState({notification:true});
                } else {
                    alert((response && response.data && response.data.message) || 'No se pudo cambiar el estado del grupo.');
                }
                this.getList();
        })
    }
    

    renderNotification = () => {
        return(
            <Notification 
                setShow={() => {this.setState({notification:false})}}
                show={this.state.notification}
                title={'Datos actualizados'}
                subtitle={'Sus datos fueron actualizados correctamente.'}
            />
        )
    }

    renderModalDetail = () => {
        return(
            <Dialog open={this.state.detailDialog} onClose={()=>console.log('dialog close')} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <RuleDetail data={this.state.rule} onBack={()=>this.setState({detailDialog:false, rule:null})}/>
                    </DialogPanel>
                    </div>
                </div>
                </Dialog>
            
        )
    }


    searchInput = () => {
        return (
            <div>
                <div className="relative mt-2 rounded-md shadow-sm">
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <MagnifyingGlassCircleIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                        id="email"
                        name="email"
                        type="text"
                        placeholder="Buscar"
                        className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm/6"
                        />
                </div>
            </div>
        )
    }


    render() {
        return(
            <div className="px-4 sm:px-6 lg:px-8">
                <div style={{marginBottom:10}}>
                    <Breadcrumb pages={this.BreadcrumbPages}/>
                </div>
                <div class="w-full p-4">
                    <div class="w-full rounded overflow-hidden shadow-lg bg-white" style={{backgroundColor:'#f1f4ff'}}>
                        <div class="px-6 py-4">
                            <p class="text-gray-700 text-base" style={{fontWeight:'bold'}}>
                                En esta sección podrás crear y administrar los diferentes grupos y accesos que tendran los usuarios de la plataforma web.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-white font-semibold text-gray-900">.</h1>
                    </div>
                    <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                        {
                            this.props.canCreate ? 
                                <button
                                    onClick={() => {this.openByDialog()}}
                                    type="button"
                                    className={BUTTON_LINE_ICON}>
                                <PlusCircleIcon aria-hidden="true" 
                                    className="h-5 w-5 text-white-400"/>
                                    NUEVO GRUPO
                                </button>
                            :
                                null
                        }
                        
                    </div>
                </div>

                {
                    this.state.loading ? (
                        <center>
                            <ClipLoader
                                color={'gray'}
                                loading={true}
                                size={50}
                                aria-label="Loading Spinner"
                                data-testid="loader"/>
                        </center>

                        ) : (
                            <>
                                <div className="sm:flex sm:items-center">
                                    {this.renderNotification()}
                                    {this.renderModalDetail()}
                                    </div>
                                    <div className="mt-8">
                                        <Paper sx={{ height: 400, width: '100%' }}>
                                            <DataGrid
                                                rows={this.state.rules.map((row, index) => ({
                                                    ...row,
                                                    id: row.id || index
                                                }))}
                                                columns={this.columns}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: { page: 0, pageSize: 10 }
                                                    }
                                                }}
                                                pageSizeOptions={[5, 10, 25]}
                                                disableRowSelectionOnClick
                                                disableColumnFilter
                                                disableColumnMenu
                                                localeText={{ 
                                                    noRowsLabel: "No hay grupos para mostrar",
                                                    footerRowSelected: (count) => `${count} fila(s) seleccionada(s)`,
                                                    footerTotalRows: 'Total de filas:',
                                                    footerPaginationRowsPerPage: 'Filas por página:',
                                                }}
                                                sx={{
                                                    '& .MuiDataGrid-cell:hover': {
                                                        color: 'primary.main',
                                                    },
                                                    '& .MuiDataGrid-row:hover': {
                                                        backgroundColor: '#f5f5f5',
                                                    }
                                                }}
                                            />
                                        </Paper>
                                    </div>
                                    </>
                        )
                }
                </div>
        )
    }
}

export default RulesList;